import { type TypographyProps } from "@octopus-energy/coral/atoms"
import { type CustomerService } from "@/features/customer-service"
import { useFormatRequestError } from "@/lib/error-intl"
import { ErrorMessageAlert } from "./ErrorMessageAlert"

type RequestErrorMessageAlertProps = {
    error: unknown
    customerService?: CustomerService
} & TypographyProps

export function RequestErrorMessageAlert({
    error,
    customerService,
    ...props
}: RequestErrorMessageAlertProps) {
    const formatRequestError = useFormatRequestError()

    const errorMessage = formatRequestError(error)

    if (!errorMessage) {
        return null
    }

    return (
        <ErrorMessageAlert
            errorMessage={errorMessage}
            customerService={customerService}
            {...props}
        />
    )
}

RequestErrorMessageAlert.messages = [
    ...ErrorMessageAlert.messages,
    ...useFormatRequestError.messages,
] as const
